export default __webpack_public_path__ + "static/media/ZoomIn.409c1c22.svg";